export const JoiningChannelKey = 'v2_joining_channel';
